import type {
  FiltersInQuickSearch,
  FiltersInQuickSearchValues,
  FilterType,
  QuickSearchFilters,
} from '@/scopes/search/quick-search/domain/types'
import { createContext } from 'react'

interface QuickSearchActionsContextType {
  initQuickSearch: (params: { publicationCode: string, contextItemId: string, initialSelection: QuickSearchFilters }) => Promise<void>
  filterConfirmed: (params: { type: FilterType, selection: FiltersInQuickSearchValues }) => Promise<void>
  switchPublicationCode: (publicationCode: string, selection: Partial<FiltersInQuickSearch>) => Promise<void>
}

export const QuickSearchActionsContext = createContext<QuickSearchActionsContextType>({
  initQuickSearch: async () => {},
  filterConfirmed: async () => {},
  switchPublicationCode: async () => {},
})
